import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import CabinsFullWidth from "../components/cabinsFullWidth"
import GettingHereComponent from "../components/gettingHere"

const GettingHere = () => {
  return (
    <Layout>
      <SEO
        title="Getting Here"
        description="How to reach Gold Coast Retreat in Tofino, BC — ferry, flight, and driving directions to Chesterman Beach on Vancouver Island's west coast."
      />
      <GettingHereComponent />
      <CabinsFullWidth />
    </Layout>
  )
}

export default GettingHere
